import basicController from "servicestack/basic.controller.properties";
import $resolve from "ng";
import authConfig from "emun.auth/auth.config"; //get shared
import modals from "webmodals/modals";

export default class ShowModePromptController {
  constructor() {
    const $ctrl = this;
    basicController($ctrl);
    $ctrl.config = authConfig;
    $ctrl.bus = $ctrl.$session.bus;
    delete $ctrl.bus.validationErrors;
    console.debug("ShowModePromptController", this);
    this.bus
      .read("GetShowSettings.json")
      .then((r) => {
            $ctrl.showCodes = r.data.showCodes;
      });

  }

  submit() {
    let $ctrl = this;
    $ctrl.bus.send("EnterShowMode.json", {
      UserAuthId: $ctrl.$session.userAuthId,
      ShowCode: $ctrl.showCode
    }).then(function(res) {
      $ctrl.$dismiss();
      location.reload();
    });
  }

}
